'use strict';/* global define */define('modules/core/modules/utils/services/token-policy/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["LocalStorage", "BrowserMode"];
function factory(LocalStorage,BrowserMode){// jshint validthis:true
// jshint latedef:false
return{getRefreshAccessToken:getRefreshAccessToken,getRefreshAccessTokenUserSetting:getRefreshAccessTokenUserSetting,setRefreshAccessTokenUserSetting:setRefreshAccessTokenUserSetting};// ---
/**
     * Gets the refresh policy of the application
     * this is set to true, iff
     * - the user is not browsing incognito and the refresh user-setting is true
     *
     * @return {boolean} - Refresh policy
     *
     * @tested
     */function getRefreshAccessToken(){var userSetting=getRefreshAccessTokenUserSetting();return!BrowserMode.isIncognito()&&userSetting;}/**
     * Gets the refresh user-setting
     * this is used in the refresh policy of the application
     *
     * @return {boolean} - Refresh user-setting
     *
     * @tested
     */function getRefreshAccessTokenUserSetting(){var stored=LocalStorage.getItem('refresh-access-token');return stored===null||stored==='true';}/**
     * Sets the refresh user-setting
     * this is used in the refresh policy of the application
     *
     * @param {boolean} value - new refresh user-setting
     *
     * @tested
     */function setRefreshAccessTokenUserSetting(value){LocalStorage.setItem('refresh-access-token',value);}}module.exports=factory;});
